module.exports = __webpack_public_path__ + "static/media/CTLI_9-147w.64edc573.webp";